import React, { useEffect, useState } from 'react'
import '../styles/program.scss'



export default function Cinema({ allOrganizers, setCinemaID, resetCinema, setResetCinema, regarr, cinemaarr, setCinemaarr, cinemaIds, setCinemaIds, menuClickHandler , showItem }) {

      
    const [isCinemaOpen, setIsCinemaOpen] = useState(false);
    const [city, setCity] = useState('')
    const [toggle, setToggle] = useState(true)
    const [chosenCinema, setChosenCinema] = useState('Vælge biograf');
    const [chosenCinemaCity, setChosenCinemaCity] = useState('')
    // const [Dd, setDd] = useState({data.map(item.id)});
   
    function handleArrrow() {
        setIsCinemaOpen((current) => !current);
    }

  
    useEffect(() => {
        resetCinema == true && setChosenCinema('Vælge biograf')
        resetCinema == true && setChosenCinemaCity(' ')


    }, [resetCinema])

    function handleCheck(item) {
       
        setCity(item.city)
        if (cinemaarr.includes(item.name)) {
            setCinemaarr(cinemaarr.filter(r => { return r !== item.name }))
            setCinemaIds(cinemaIds.filter(r => { return r !== item._no }))
        }
        else setCinemaarr([...cinemaarr, item.name]), setCinemaIds([...cinemaIds, item._no])
     

        setResetCinema(false)
    }
    
    return (
       
           

        <div className='dropdownContainer'>
                   {/* <p className="region-title">Biograf</p>*/}
            <div className='chooseRegion' style={{
                borderBottomLeftRadius: isCinemaOpen ? '0px' : '8px',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                borderBottomRightRadius: isCinemaOpen ? '0px' : '8px',
} } >
                        <div
                            style={{
                        position: "relative",
                      
                            //    padding: "5px 8px",
                        boxSizing: "border-box",
                       
                              //  height: "31px",
                    }}  >
                    <p className='dropdownTitle' > {cinemaarr && cinemaarr?.length === 1 ? cinemaarr[0] : cinemaarr?.length > 0 ? 'Valgte biografer' : 'Biograf'} {cinemaarr?.length === 1 && '/ ' + city}</p>
                    {cinemaarr?.length > 0 && cinemaarr?.length && < span className="one"> {cinemaarr.length} </span>}
                            
                    <button className='chooseBtn'
                        onClick={() => { handleArrrow(); menuClickHandler('biograf') }}
                              
                            >
                        <p className={showItem === "biograf" ? "rotate down" : "rotate "}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                                <path d="M1.5 1L10 10L18.5 1" stroke="white" stroke-width="2" stroke-linecap="round" />
                            </svg>
                                </p>
                            </button>
                        </div>
                    </div>
            {showItem === "biograf" &&
                <div className={`scroll  ${showItem === "biograf" ? 'dropdown_show' : null}`} >
                {allOrganizers && allOrganizers.map((item) => (

                    <div key={item._no } onClick={() => handleCheck(item)}
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        height: "44px",
                                        padding: "10px 10px 10px 16px",
                                        marginRight: '2px',
                                        marginBottom: '4px',
                                        width: '95%',borderRadius:'6px',
                                        backgroundColor: cinemaarr.length && cinemaarr.includes(item.name) ? '#3E455C': ''

                                    }}
                    >
                        <p className='dropdowns-lists'>{item.name} / {item.city}</p>
                      
                       
                            {cinemaarr.length && cinemaarr.includes(item.name)?
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                    <path d="M7 11L11 16L17.5 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                : 
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                </svg>
                                        }
                                   
                                </div>
                            ))}

                        </div>
                    }

                </div>

        
        
        )
}